import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCharactersGradeHskPageQueryOptions } from "#use-characters-grade-hsk-page-query-options";
import { useCallback } from "react";

/** Characters → HSK view: every HSK level concatenated into one scrollable, sectioned by band. */
function useNavigator() {
  const charactersGradeHskPageQueryOptions = useCharactersGradeHskPageQueryOptions();

  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/browse/(browse-tabs)/characters/grade/hsk",
      },
      queries: [charactersGradeHskPageQueryOptions],
    }),
    [charactersGradeHskPageQueryOptions],
  );
}

export const useBrowseCharactersHskPageNavigator = createPageNavigator<void>({
  useNavigator,
});
